// extracted by mini-css-extract-plugin
module.exports = {"box":"index-module_box_PZGvt","group":"index-module_group_Zz_0Y","el-submenu":"index-module_el-submenu_2OzJD","el-menu-item":"index-module_el-menu-item_YouL-"};